import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DomService } from '../services/dom.service';
import { ModalService } from './services/modal.service';
import { ModalComponent } from './components/modal.component';
import { OverlayContainer } from '../overlay/overlay-container';

@NgModule({
    imports: [
        CommonModule,
    ],
    declarations: [
        ModalComponent,
    ],
    entryComponents: [
        ModalComponent,
    ],
    providers: [
        DomService,
        ModalService,
        OverlayContainer,
    ],
})

export class ModalModule {}
